import { TextField } from '@mui/material';
import { IFormFieldTextMeta } from '../../../view-models/form.view-model';
import { formTextFieldInlineClassNames } from '../../../theme/component-styles';
import { IBaseFieldProps } from './types';

export function FieldText(props: IBaseFieldProps<IFormFieldTextMeta>) {
  const { formField, formProps } = props;
  const { autoFocus = false, disabled = false, fullWidth, variant } = formField;
  const { onChange, onBlur } = formProps;
  const { maxRows, multiline, rows } = formField.rendererMeta ?? {};
  const className = variant === 'form-inline' ? formTextFieldInlineClassNames : '';

  return (
    <TextField
      autoFocus={autoFocus}
      className={className}
      disabled={disabled}
      fullWidth={fullWidth}
      maxRows={maxRows}
      multiline={multiline}
      onBlur={onBlur}
      onChange={onChange}
      placeholder={formField.placeholder}
      rows={rows}
      // The shared `Label` beside this renders no `htmlFor`, and the input carries no id, so
      // without this the control has no accessible name at all.
      slotProps={{ htmlInput: { 'aria-label': formField.label } }}
      value={formProps.value ?? ''}
    />
  );
}
